export default __webpack_public_path__ + "static/media/banner4.2d0723c4.png";